import React, { useEffect, useState } from 'react';
// material-ui
import { Box, FormControl, Grid, MenuItem, Select, Typography } from '@mui/material';

// project imports
import { gridSpacing } from 'store/constant';
import api from '../../api';
import SupportTable from 'components/tables/SupportTable';
import CustomDropdown from 'components/dropdown/CustomDropdown';

// ==============================|| SUPPORT PAGE ||============================== //

const Support = () => {
  const [supportData, setSupportData] = useState([]);
  const [statusFilter, setStatusFilter] = useState('OPEN');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSupportData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/support/tickets?page=${page + 1}&limit=${limit}&status=${statusFilter}`);
        if (response.status === 200) {
          console.log('response :>> ', response);
          setSupportData(response.data.data);
          console.log('supportData :>> ', supportData);
          setTotalCount(response.data.total);
        }
      } catch (error) {
        console.error('Error fetching support tickets:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSupportData();
  }, [page, limit, statusFilter]);

  return (
    <>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Box
            sx={{
              background: 'white',
              padding: '24px',
              borderRadius: '15px',
              boxShadow: '7px 7px 10px rgba(0, 0, 0, 0.1), inset -5px -5px 5px rgba(255, 255, 255, 0.9)'
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography style={{ fontSize: '20px', lineHeight: '30px', fontWeight: '500' }}>Support</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 2 }}>
                <CustomDropdown
                  label="Status"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  options={statusOptions}
                />
              </Box>
              <Box>
                <SupportTable
                  loading={loading}
                  supportData={supportData}
                  page={page}
                  limit={limit}
                  total={totalCount}
                  onPageChange={(newPage) => setPage(newPage)}
                  onLimitChange={(newLimit) => {
                    console.log('newLimit :>> ', newLimit);
                    setLimit(newLimit);
                    setPage(0);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Support;

const statusOptions = [
  { value: 'OPEN', label: 'Open' },
  { value: 'CLOSED', label: 'Closed' }
];

const SupportData1 = [
  {
    _id: '1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    title: 'Login Issue',
    description: 'Unable to log in with my credentials. Getting an "Invalid Password" error.',
    userId: {
      _id: 'user-1',
      name: 'John Smith',
      email: 'john.smith@example.com'
    },
    status: 'CLOSED',
    isDeleted: false,
    createdAt: '2025-04-01T10:30:00Z',
    updatedAt: '2025-04-01T10:30:00Z',
    __v: 0
  },
  {
    _id: '680c554c4f1625f9e70c44fa',
    title: 'Issue with Login',
    description: 'Unable to login',
    userId: {
      _id: '66cd98c8095150db797cd1b5',
      name: 'QA TEST',
      email: 'zohaibfundmanager@gmail.com'
    },
    status: 'OPEN',
    isDeleted: false,
    createdAt: '2025-04-26T03:38:52.093Z',
    updatedAt: '2025-04-26T03:43:37.703Z',
    __v: 0
  },
  {
    _id: '3c4d5e6f-7g8h-9i0j-1k2l-3m4n5o6p7q8',
    title: 'Investment Opportunity Question',
    description: 'Need clarification on the minimum investment amount for Deal #123.',
    userId: {
      _id: 'user-3',
      name: 'Michael Chen',
      email: 'michael.chen@example.com'
    },
    status: 'OPEN',
    isDeleted: false,
    createdAt: '2025-04-03T09:45:00Z',
    updatedAt: '2025-04-03T09:45:00Z',
    __v: 0
  },
  {
    _id: '4d5e6f7g-8h9i-0j1k-2l3m-4n5o6p7q8r9',
    title: 'Dashboard Data Not Loading',
    description: 'Performance metrics aren’t showing up on my fund dashboard.',
    userId: {
      _id: 'user-4',
      name: 'Emily Rodriguez',
      email: 'emily.rodriguez@example.com'
    },
    status: 'OPEN',
    isDeleted: false,
    createdAt: '2025-04-04T16:20:00Z',
    updatedAt: '2025-04-04T16:20:00Z',
    __v: 0
  },
  {
    _id: '5e6f7g8h-9i0j-1k2l-3m4n-5o6p7q8r9s0',
    title: 'Payment Processing Delay',
    description: 'Sent a payment 3 days ago, but it’s still not reflected in my account.',
    userId: {
      _id: 'user-5',
      name: 'David Patel',
      email: 'david.patel@example.com'
    },
    status: 'OPEN',
    isDeleted: false,
    createdAt: '2025-04-05T11:10:00Z',
    updatedAt: '2025-04-05T11:10:00Z',
    __v: 0
  },
  {
    _id: '6f7g8h9i-0j1k-2l3m-4n5o-6p7q8r9s0t1',
    title: 'Feature Request: Export Reports',
    description: 'Would like ability to export performance reports as PDF.',
    userId: {
      _id: 'user-6',
      name: 'Lisa Thompson',
      email: 'lisa.thompson@example.com'
    },
    status: 'OPEN',
    isDeleted: false,
    createdAt: '2025-04-06T13:55:00Z',
    updatedAt: '2025-04-06T13:55:00Z',
    __v: 0
  },
  {
    _id: '7g8h9i0j-1k2l-3m4n-5o6p-7q8r9s0t1u2',
    title: 'Account Verification Issue',
    description: 'Uploaded ID documents but verification is still pending after 48 hours.',
    userId: {
      _id: 'user-7',
      name: 'Robert Wilson',
      email: 'robert.wilson@example.com'
    },
    status: 'OPEN',
    isDeleted: false,
    createdAt: '2025-04-07T15:30:00Z',
    updatedAt: '2025-04-07T15:30:00Z',
    __v: 0
  }
];

const SupportData = [
  {
    id: '1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    ticketId: '10001',
    title: 'Login Issue',
    description: 'Unable to log in with my credentials. Getting an "Invalid Password" error.',
    role: 'investor',
    senderName: 'John Smith',
    createdAt: '2025-04-01T10:30:00Z',
    msg: [
      {
        _id: 'msg-001',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi John, have you tried resetting your password using the "Forgot Password" link?',
        type: 'response',
        createdAt: '2025-04-01T11:00:00Z'
      },
      {
        _id: 'msg-002',
        role: 'investor',
        name: 'John Smith',
        msg: 'Yes, I tried that, but I’m not receiving the reset email.',
        type: 'query',
        createdAt: '2025-04-01T11:30:00Z'
      },
      {
        _id: 'msg-003',
        role: 'admin',
        name: 'Support Team',
        msg: 'Thanks for letting us know. We’ll check your email settings and resend the reset link.',
        type: 'response',
        createdAt: '2025-04-01T12:00:00Z'
      }
    ]
  },
  {
    id: '2b3c4d5e-6f7g-8h9i-0j1k-2l3m4n5o6p7',
    ticketId: '10002',
    title: 'Fund Document Upload Failure',
    description: 'Trying to upload quarterly report but it keeps timing out.',
    role: 'fundmanager',
    senderName: 'Sarah Johnson',
    createdAt: '2025-04-02T14:15:00Z',
    msg: [
      {
        _id: 'msg-004',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi Sarah, can you confirm the file size of the report? It might be exceeding our limit.',
        type: 'response',
        createdAt: '2025-04-02T14:45:00Z'
      },
      {
        _id: 'msg-005',
        role: 'fundmanager',
        name: 'Sarah Johnson',
        msg: 'The file is 15MB. Is that too large?',
        type: 'query',
        createdAt: '2025-04-02T15:00:00Z'
      }
    ]
  },
  {
    id: '3c4d5e6f-7g8h-9i0j-1k2l-3m4n5o6p7q8',
    ticketId: '10003',
    title: 'Investment Opportunity Question',
    description: 'Need clarification on the minimum investment amount for Deal #123.',
    role: 'investor',
    senderName: 'Michael Chen',
    createdAt: '2025-04-03T09:45:00Z',
    msg: [
      {
        _id: 'msg-006',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi Michael, the minimum investment for Deal #123 is $10,000. Let us know if you have more questions!',
        type: 'response',
        createdAt: '2025-04-03T10:15:00Z'
      },
      {
        _id: 'msg-007',
        role: 'investor',
        name: 'Michael Chen',
        msg: 'Thanks! Is there a deadline for this investment?',
        type: 'query',
        createdAt: '2025-04-03T10:30:00Z'
      },
      {
        _id: 'msg-008',
        role: 'admin',
        name: 'Support Team',
        msg: 'The deadline is April 15, 2025. We recommend submitting your commitment soon!',
        type: 'response',
        createdAt: '2025-04-03T11:00:00Z'
      }
    ]
  },
  {
    id: '4d5e6f7g-8h9i-0j1k-2l3m-4n5o6p7q8r9',
    ticketId: '10004',
    title: 'Dashboard Data Not Loading',
    description: 'Performance metrics aren’t showing up on my fund dashboard.',
    role: 'fundmanager',
    senderName: 'Emily Rodriguez',
    createdAt: '2025-04-04T16:20:00Z',
    msg: [
      {
        _id: 'msg-009',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi Emily, we’re looking into this issue. Can you try clearing your browser cache?',
        type: 'response',
        createdAt: '2025-04-04T16:45:00Z'
      },
      {
        _id: 'msg-010',
        role: 'fundmanager',
        name: 'Emily Rodriguez',
        msg: 'I cleared the cache, but the metrics are still not loading.',
        type: 'query',
        createdAt: '2025-04-04T17:00:00Z'
      }
    ]
  },
  {
    id: '5e6f7g8h-9i0j-1k2l-3m4n-5o6p7q8r9s0',
    ticketId: '10005',
    title: 'Payment Processing Delay',
    description: 'Sent a payment 3 days ago, but it’s still not reflected in my account.',
    role: 'investor',
    senderName: 'David Patel',
    createdAt: '2025-04-05T11:10:00Z',
    msg: [
      {
        _id: 'msg-011',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi David, we’ve identified a delay with our payment processor. We’re working on it.',
        type: 'response',
        createdAt: '2025-04-05T11:30:00Z'
      },
      {
        _id: 'msg-012',
        role: 'investor',
        name: 'David Patel',
        msg: 'Thanks for the update. Any ETA on when this will be resolved?',
        type: 'query',
        createdAt: '2025-04-05T12:00:00Z'
      },
      {
        _id: 'msg-013',
        role: 'admin',
        name: 'Support Team',
        msg: 'We expect it to be resolved by end of day. We’ll notify you once it’s updated.',
        type: 'response',
        createdAt: '2025-04-05T12:30:00Z'
      }
    ]
  },
  {
    id: '6f7g8h9i-0j1k-2l3m-4n5o-6p7q8r9s0t1',
    ticketId: '10006',
    title: 'Feature Request: Export Reports',
    description: 'Would like ability to export performance reports as PDF.',
    role: 'fundmanager',
    senderName: 'Lisa Thompson',
    createdAt: '2025-04-06T13:55:00Z',
    msg: [
      {
        _id: 'msg-014',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi Lisa, thanks for the suggestion! We’ll pass this on to our development team.',
        type: 'response',
        createdAt: '2025-04-06T14:15:00Z'
      },
      {
        _id: 'msg-015',
        role: 'fundmanager',
        name: 'Lisa Thompson',
        msg: 'Great, any timeline for when this might be implemented?',
        type: 'query',
        createdAt: '2025-04-06T14:30:00Z'
      }
    ]
  },
  {
    id: '7g8h9i0j-1k2l-3m4n-5o6p-7q8r9s0t1u2',
    ticketId: '10007',
    title: 'Account Verification Issue',
    description: 'Uploaded ID documents but verification is still pending after 48 hours.',
    role: 'investor',
    senderName: 'Robert Wilson',
    createdAt: '2025-04-07T15:30:00Z',
    msg: [
      {
        _id: 'msg-016',
        role: 'admin',
        name: 'Support Team',
        msg: 'Hi Robert, we’re experiencing a backlog in verifications. We’ll expedite your request.',
        type: 'response',
        createdAt: '2025-04-07T16:00:00Z'
      },
      {
        _id: 'msg-017',
        role: 'investor',
        name: 'Robert Wilson',
        msg: 'Thanks, can you confirm if my documents were received correctly?',
        type: 'query',
        createdAt: '2025-04-07T16:15:00Z'
      },
      {
        _id: 'msg-018',
        role: 'admin',
        name: 'Support Team',
        msg: 'Yes, your documents were received. We’ll have this resolved within 24 hours.',
        type: 'response',
        createdAt: '2025-04-07T16:45:00Z'
      }
    ]
  }
];
